import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 384 512" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.764 233.282C.296 235.167 0 236.952 0 256c0 19.337.264 20.815 4.086 22.908C5.953 279.93 17.968 280 192 280c174.032 0 186.047-.07 187.914-1.092C383.736 276.815 384 275.337 384 256c0-19.179-.292-20.885-3.895-22.748-2.688-1.391-373.782-1.361-376.341.03" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "min"}) } }